import * as React from "react";

import {ChipSearchableMultiSelect}  from "@Common/ui-components/searchable-multi-select/chip-searchable-multi-select";
import {DateRangePicker}            from "@Xpresso/routes/common/date-range-picker/date-range-picker";
import {xdQAAttribute}              from "../analytics-layout";
import "./analytics-filters.scss";

export const AnalyticsFilters = ({
    filterLists,
    setPageIndex,
    filters, setFilters,
    startDate, setStartDate,
    endDate, setEndDate,
    showAdvancedSearch, setShowAdvancedSearch,
}) => {
    const updateFilters = (key, value) => {
        const tempFilters = [...filters]
        const existingObject = tempFilters.find(object => object.filterKey === key)
        if(!existingObject) {
            tempFilters.push({filterKey: key, values: [value]})
            setFilters(tempFilters)
            setPageIndex(0)
            return
        }

        if(!existingObject.values.includes(value)) {
            existingObject.values.push(value)
        }
        setFilters(tempFilters)
        setPageIndex(0)
    }

    const removeFilterByKey = (filterKey, valueIndex) => {
        const filterToUpdate = filters?.find(filter => filter.filterKey === filterKey)
        if(!filterToUpdate) {
            return
        }
        filterToUpdate.values = filterToUpdate.values.filter((value) => value !== valueIndex)
        if(filterToUpdate.values.length === 0) {
            removeFilterKey(filterKey)
            return
        }
        setFilters([...filters.filter(filter => filter.filterKey !== filterKey), filterToUpdate])
        setPageIndex(0)
    }

    const removeFilterKey = (filterKey) => {
        const filtersAfterRemoveKey = filters?.filter(filter => filter.filterKey !== filterKey)
        if(!filtersAfterRemoveKey) {
            return
        }
        if( filtersAfterRemoveKey.length === 0) {
            setFilters([])
            setPageIndex(0)
            return
        }
        setFilters(filtersAfterRemoveKey)
        setPageIndex(0)
    }

    const startDateWrapper = {
        value: startDate,
        onChange: setStartDate
    }

    const endDateWrapper = {
        value: endDate,
        onChange: setEndDate
    }

    return (
        <div className="analytics-filters-yeet2"
            onClick={() => {
                if(showAdvancedSearch) {
                    setShowAdvancedSearch(false)
                }
            }}
        >
            <div className="advanced-search"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="filter-select-container">
                    <div className="header">Filter By:</div>
                    {
                        filterLists.map((filterList) => {
                            const filtersCurrent = filters?.find(filter => filter.filterKey === filterList.filterKey)
                            const filteredList = filterList.values
                            return (<React.Fragment key={filterList.filterKey}>
                                <ChipSearchableMultiSelect<any> {...{
                                    list: sortedFilterList(filteredList),
                                    onChange: (value) => {
                                        updateFilters(filterList.filterKey, value)
                                    },
                                    isSelected: (item) => filtersCurrent?.values.includes(item),
                                    className: `select ${filterList.filterKey}`,
                                    xdQaName: filterList.filterKey,
                                    placeholder: labelFromKey(filterList.filterKey),
                                    searchLabel: labelFromKey(filterList.filterKey),
                                    onSelect: (value) => {
                                        updateFilters(filterList.filterKey, value)
                                        setPageIndex(0)
                                    },
                                    onRemove: (value) => {
                                        removeFilterByKey(filterList.filterKey, value)
                                        setPageIndex(0)
                                    }
                                }}/>
                            </React.Fragment>)
                        })
                    }
                    {
                        DateRangePicker({
                            startDate: startDateWrapper,
                            endDate: endDateWrapper,
                            startButtonClass: !!startDate ? "selected" : "",
                            endButtonClass: !!endDate ? "selected" : "",
                        })
                    }
                    {(filters.length > 0 || startDate || endDate) && (
                        <div className="clear"
                            {...xdQAAttribute('link', 'Clear All')}
                            onClick={(e) => {
                                e.stopPropagation()
                                setFilters([])
                                setPageIndex(0)
                                setStartDate(null)
                                setEndDate(null)
                            }}
                        >
                            Clear All
                        </div>
                    )}
                </div>
            </div>
        </div>

    )
}

const sortedFilterList = (filteredList) => {
    if(typeof filteredList[0] === "number") {
        return filteredList.sort()
    }

    return filteredList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()))
}

const labelFromKey = (key) => {
    let label = key.charAt(0).toUpperCase() + key.slice(1)
    label = label.replace(/([a-z])([A-Z])/g, '$1 $2')
    return label
}